
import React from 'react';
import { Controller } from "./Controller";
import { BasicButton, BreadcrumbContainer, ButtonGroup, LoadingCurtain, UIContainer } from './UI-styled';
//import { Page, Navbar, List, ListButton } from 'react';


interface Props {
  controller:Controller
}

export class UI extends React.Component<Props, {}> {
  renderReference: React.RefObject<HTMLDivElement>;


  constructor(props) {
    super(props);
    this.renderReference = React.createRef<HTMLDivElement>();
    this.state = {};
  }

  public componentDidUpdate = (prevProps:Readonly<Props>):void => {
    // console.warn("UI.componentDidUpdate() called!");
  }

  public toggleDoors = () => {
    const tree = this.props.controller.tree;
    tree.doorsVisible = !tree.doorsVisible;
    const apartmentMesh = tree.cursor.parent.clickMesh.getMeshParent();
    tree.setDoorVisibility(apartmentMesh, tree.doorsVisible);
    this.setState(this.state);
  }

  public toggleFurniture = () => {
    const tree = this.props.controller.tree;
    tree.furnitureVisible = !tree.furnitureVisible;

    let apartmentMesh;
    if (tree.level === 3) apartmentMesh = tree.cursor.clickMesh.getMeshParent();
    if (tree.level === 4) apartmentMesh = tree.cursor.parent.clickMesh.getMeshParent();

    tree.setFurnitureVisibility(apartmentMesh, tree.furnitureVisible);
    this.setState(this.state);
  }

  public toggleMeasurements = () => {
    const tree = this.props.controller.tree;
    tree.measurementsVisible = !tree.measurementsVisible;
    const apartmentMesh = tree.cursor.clickMesh.getMeshParent();
    tree.setMeasurementVisibility(apartmentMesh, tree.measurementsVisible);
    this.setState(this.state);
  }

  selectObj = (id:string) => {
    this.props.controller.selectById(id);
  }

  componentDidMount() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
  }

  public getLevelDesc = () => {
    const levelDescLines = this.props.controller.tree.getLevelDesc();
    return (
      <React.Fragment>

        {/* Shorten name of apartments */}
        {levelDescLines.map((line, ind) => {
          if (ind === 2) {
            line = line.replace("Linke Wohnung", "Links");
            line = line.replace("1. Linke Wohnung", "1. Links");
            line = line.replace("2. Linke Wohnung", "2. Links");
            line = line.replace("Rechte Wohnung", "Rechts");
            line = line.replace("1. Rechte Wohnung", "1. Rechts");
            line = line.replace("2. Rechte Wohnung", "2. Rechts");
            line = line.replace("Mittige Wohnung", "Mitte");
            line = line.replace("Gerade Wohnung", "Gerade");
          }
          
          return (
            <div key={ind}>{line}</div>
          );
        })}
      </React.Fragment>
    )
  }

  public getNavigationButtons = () => {
    const getRoundTourButton = () => {
      if (this.props.controller.tree.level !== 0) return null;
      const roundTourActive = this.props.controller.roundTour;
      return (
        <BasicButton 
          onClick={(e:React.MouseEvent) => {
            e.stopPropagation();
            roundTourActive ? this.props.controller.stopRoundTour() : this.props.controller.startRoundTour();
          }}
        >
          {roundTourActive ? "Außenrundgang beenden" : "Außenrundgang beginnen"}
        </BasicButton>
      )
    }

    const getBackButton = () => {
      if (this.props.controller.tree.cursor.parent === null) return null;
      const parentId = this.props.controller.tree.cursor.parent.clickMesh.id;

      return (
        <BasicButton 
          onClick={(e:React.MouseEvent) => {
            e.stopPropagation();
            this.selectObj(parentId);
          }} 
        >
          Zurück
        </BasicButton>
      )
    }

    return (
      <React.Fragment>
        {getBackButton()}
        {getRoundTourButton()}
      </React.Fragment>
    )
  }

  public getChildButtons = () => {
    const { controller } = this.props;
    let activeClickMeshId = null;
    if (controller.activeClickMesh) activeClickMeshId = controller.activeClickMesh.id; 

    return (
      <React.Fragment>
        {controller.tree.activeButtons.map((el) => {
          return (
            <BasicButton 
              key={el.id}
              isActive = {activeClickMeshId && activeClickMeshId === el.id}
              onMouseLeave={() => controller.hideAllClickMeshes()} 
              onMouseEnter={() => controller.showClickMeshById(el.id)} 
              onClick={(e:React.MouseEvent) => {
                e.stopPropagation();
                this.selectObj(el.id);
              }} 
            >
              {el.title}
            </BasicButton>
          )
        })}
      </React.Fragment>
    )
  }

  getAdditionalButtons = () => {
    const { controller } = this.props;

    if (controller.tree.level === 3) {
      return (
        <React.Fragment>
          <BasicButton 
            onClick={(e:React.MouseEvent) => {
              e.stopPropagation();
              this.toggleMeasurements();
            }} 
          >
            {controller.tree.measurementsVisible ? "Maße ausblenden" : "Maße einblenden"}
          </BasicButton>
          <BasicButton 
            onClick={(e:React.MouseEvent) => {
              e.stopPropagation();
              this.toggleFurniture();
            }}
          >
            {controller.tree.furnitureVisible ? "Möbel ausblenden" : "Möbel einblenden"}
          </BasicButton>
        </React.Fragment>
      )
    } else if (this.props.controller.tree.level === 4) {
      return (
        <React.Fragment>
          <BasicButton 
            onClick={(e:React.MouseEvent) =>{
              e.stopPropagation();
              this.toggleFurniture();
            }}
          >
            {controller.tree.furnitureVisible ? "Möbel ausblenden" : "Möbel einblenden"}
          </BasicButton>
          <BasicButton 
            onClick={(e:React.MouseEvent) => {
              e.stopPropagation();
              this.toggleDoors();
            }} 
          >
            {controller.tree.doorsVisible ? "Türen ausblenden" : "Türen einblenden"}
          </BasicButton>
        </React.Fragment>
      )
    }
  }

  public render = () => {
    const { controller } = this.props;

    if (this.props.controller.tree == null) {
      return (
        <LoadingCurtain>
          <UIContainer>
            <img key="logo" src={"./public/images/logo.png"} alt="Logo" />
          </UIContainer>
          {/* Loader from https://loading.io/css/ - CC0 license <3 - Weird nested div-structure is needed for loader styling */}
          <div className="lds-ring"> 
            <div className="loader-styling-helper-1"></div>
            <div className="loader-styling-helper-2"></div>
            <div className="loader-styling-helper-3"></div>
            <div className="loader-styling-helper-4"></div>
          </div> 
        </LoadingCurtain>
      )
    }

    const additionalButtons = this.getAdditionalButtons();

    return (
      <UIContainer>
        <img key="logo" src={"./public/images/logo.png"} style={{ width: "100%" }} alt="Logo" />

        {!controller.roundTour &&
          <BreadcrumbContainer>
            {this.getLevelDesc()}
          </BreadcrumbContainer>
        }
        
        <ButtonGroup>
          {this.getNavigationButtons()}
        </ButtonGroup>

        {!controller.roundTour &&
          <ButtonGroup>
            {this.getChildButtons()}
          </ButtonGroup>
        }

        {additionalButtons &&
          <ButtonGroup>
            {this.getAdditionalButtons()}
          </ButtonGroup>
        }
      </UIContainer>
    )
  }
}
